// CART
export const UPDATE_INFO_ORDER = 'update_info_order';
